import {
  IItem,
  AbstractDrawableValuedItem,
  DateItem,
  IValueContainable,
  instanceOfIFontSizeAutoAdjustable,
} from "../../../../../../../domain/document/items";
import { IValueAccessible } from "../IValueAccessible";
import { AbstractValueAccessor, AbstractItemValueAccessor } from "./AbstractValueAccessor";

export class DateValueAccessor extends AbstractValueAccessor<Date> {
  constructor(source: IItem) {
    super(DateValueAccessor._createAccessor(source));
  }

  private static _createAccessor(source: IItem): IValueAccessible<Date> {
    if (source instanceof DateItem) {
      return new DateItemFreeDateAccessor(source);
    }
    throw new Error("対象外オブジェクト");
  }
}

abstract class AbstractDateValueAccessor<T extends IItem & IValueContainable> extends AbstractItemValueAccessor<T, Date> {
  constructor(source: T) {
    super(source);
  }

  protected _set(source: T, value: Date): void {
    this.__set(source, value);
    if (source instanceof AbstractDrawableValuedItem) { // TODO: リファクタ.適切なinterfaceを定義すべき.
      source.adjustObjectHeight();
    }
    if (instanceOfIFontSizeAutoAdjustable(source)) {
      source.adjustFontSize();
    }
  }

  protected abstract __set(source: T, value: Date): void;
}

class DateItemFreeDateAccessor extends AbstractDateValueAccessor<DateItem> {
  constructor(source: DateItem) {
    super(source);
  }

  protected _validate(source: DateItem): void {
    if (source.isFreeInputable && source.shouldInputFree) {
      throw new Error("フリー入力");
    }
    if (!source.value) {
      throw new Error("値未設定");
    }
    if (source.value.isTime) {
      throw new Error("非日付(時刻)");
    }
    if (!!source.value.value && (typeof(source.value.value) === "string")) {
      throw new Error("非日付(文字列)");
    }
  }

  protected _get(source: DateItem): Date {
    return source.value.value;
  }

  protected __set(source: DateItem, value: Date): void {
    source.value.value = value;
  }
}
